import { CommonOrderModel } from './common-order.model';
import * as CommonOrderActions from './common-order.actions';
import { createReducer, on, Action } from '@ngrx/store';

const initialState: CommonOrderModel = new CommonOrderModel();

const reducer = createReducer(
  initialState,
  on(CommonOrderActions.setCommonOrderReference, (state, { orderReference }) => ({ ...state, orderReference }))
);

export function commonOrderReducer(state: CommonOrderModel, action: Action) {
  return reducer(state, action);
}
